// Shared blocking head bundle used by all pages.
// Manage the list of files in ./files.js.
console.info('[HEAD-BUNDLE] index.js EXECUTING (synchronous start)');

(function(){
  try {
    // Minimal global namespace for early flags if needed
    window.__STOCKSTORM_HEAD = (window.__STOCKSTORM_HEAD || {});
    window.__STOCKSTORM_HEAD.shared = true;
    window.__STOCKSTORM_HEAD.loadedAt = Date.now();
    // Lightweight diagnostic log to confirm head bundle execution order
    if (typeof console !== 'undefined' && console.log) {
      console.log('StockStorm: head bundle loaded');
    }

    // Suppress internal Lightweight Charts 'Object is disposed' errors globally
    window.addEventListener('error', (event) => {
      if ((event.message || '').includes('Object is disposed') || 
          (event.error && (event.error.message || '').includes('Object is disposed'))) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    });
    window.addEventListener('unhandledrejection', (event) => {
      if (event.reason && (event.reason.message || event.reason.toString() || '').includes('Object is disposed')) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    });
  } catch (_) { /* no-op */ }
})();

// Import ordered side-effect modules for head
import './files.js';

// Keep this file tiny. Avoid heavy imports; prefer deferring non-critical code.
